import {
  BkFilter,
  PageFilter,
  PaginationFilter,
} from './model/pagination/filter';
import { ObjectUtils } from './utils/object-utils';

export class FilterParser {
  static parseFilter(filter: BkFilter): any {
    const state = ObjectUtils.getParsedValue(filter.state);
    const lookupModuleCode = ObjectUtils.getParsedValue(filter.lookupModuleCode);
    const lookupSetting = ObjectUtils.getParsedValue(filter.lookupSetting);
    const vmFilters = {
      state: ObjectUtils.isValueNull(state) ? null : { eq: state },
      lookupModuleCode: ObjectUtils.isValueNull(lookupModuleCode) ? null : { eq: lookupModuleCode },
      lookupSetting: ObjectUtils.isValueNull(lookupSetting) ? null : { contains: lookupSetting },
      employeeId: ObjectUtils.isValueNull(filter.employeeId)
        ? null
        : { eq: filter.employeeId },
      loanTypeId: ObjectUtils.isValueNull(filter.loanTypeId)
        ? null
        : { eq: filter.loanTypeId },
        parentId: ObjectUtils.isValueNull(filter.parentId)
        ? null
        : { eq: filter.parentId },
      leaveTypeId: ObjectUtils.isValueNull(filter.leaveTypeId)
        ? null
        : { eq: filter.leaveTypeId },
      categoryId: ObjectUtils.isValueNull(filter.categoryId)
        ? null
        : { eq: filter.categoryId },
      positionId: ObjectUtils.isValueNull(filter.positionId)
        ? null
        : { eq: filter.positionId },
      clientId: ObjectUtils.isValueNull(filter.clientId)
        ? null
        : { eq: filter.clientId },
      reimbursementTypeId: ObjectUtils.isValueNull(filter.reimbursementTypeId)
        ? null
        : { eq: filter.reimbursementTypeId },
      date:
        filter.startDate && filter.endDate
          ? {
              gte: filter.startDate,
              lte: filter.endDate,
            }
          : filter.date
          ? { eq: filter.date }
          : filter.fromDate && filter.toDate
          ? { gte: filter.fromDate, lte: filter.toDate }
          : filter.fromDate
          ? { gte: filter.fromDate }
          : filter.toDate
          ? {
              lte: filter.toDate,
            }
          : null,
      inDateTime:
        filter.inDateTimeStart && filter.inDateTimeEnd
          ? {
              gte: filter.inDateTimeStart,
              lt: filter.inDateTimeEnd,
            }
          : null,
      machine: ObjectUtils.isValueNull(filter.machine)
        ? null
        : { eq: filter.machine },
      userId: ObjectUtils.isValueNull(filter.userId)
        ? null
        : { eq: filter.userId },
      accountId: ObjectUtils.isValueNull(filter.accountId)
        ? null
        : { eq: filter.accountId },
      id: filter.ids?.length > 0 ? { in: filter.ids } : null,
      departmentId: ObjectUtils.isValueNull(filter.departmentId)
        ? null
        : { eq: filter.departmentId },
    };

    ObjectUtils.removeNullValues(vmFilters);
    return vmFilters;
  }
  static parsePageFilter(filter: PageFilter): PaginationFilter {
    const pFilter: PaginationFilter = {
      skip: 0,
      take: 12,
    };
    pFilter.take = Number.isFinite(+filter.take) ? +filter.take : 12;
pFilter.skip = Number.isFinite(+filter.pageIndex)
  ? +filter.pageIndex * pFilter.take
  : 0;
    return pFilter;
  }
}
